import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import PageHero from "../ones/PageHero";
import ContactUsContent from "../ones/ContactUsContent";
import Footer from "../ones/Footer";
import { companyInfo } from "../data/siteContent";

export default function ContactUsLanding() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <>
      <PageHero
        title="Let's plan the next geospatial solution for your project"
        description={`Reach AGS by phone, email, or visit our headquarters at ${companyInfo.headquarters}. We are ready to support you`}
        badge="Contact Us"
      />
      <ContactUsContent />
      <Footer />
    </>
  );
}
